import { Colors, colors } from '@microfrontends/react-components'
import styled from 'styled-components'

export const StyledFilterBar = styled.div<{ $language?: string }>`
    .filter-footer {
        position: sticky;
        bottom: 0;
        z-index: 5;
        width: 100%;
        padding: 16px;
        box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.15);
        background: white;
        .btn {
            color: white;
            background: #ff7d55;
            border-color: #ff7d55;
            font-size: 1.1rem;
        }
    }

    .multi-category {
        .select-container {
            -webkit-flex-wrap: inherit !important;
            -ms-flex-wrap: inherit !important;
            flex-wrap: inherit !important;
            -webkit-flex-wrap: inherit !important;
            > span {
                padding-left: 0 !important;
            }
            .multiple-select-selected-values {
                padding-top: 5px !important;
                padding-left: 0 !important;
                padding-right: 14px;
            }
            .select-dropdown {
                max-width: 320px !important;
                top: 40px !important;
            }
        }
    }

    .desktop {
        display: flex;
        gap: 8px;
        flex-direction: column;
        border-radius: 12px;
        padding: 12px;
        background-color: #fff;
        box-shadow: 0 1px 8px rgba(0, 0, 0, 0.12);
    }

    .desktop-filter-bar {
        padding: 6px !important;
        gap: 0 !important;
    }

    .desktopFilter {
        display: flex;
        flex-direction: row;
    }

    .mobile {
        display: none;
    }

    .action {
        display: inline-flex;
        align-items: center;
        transition: 0.25s;

        .icon {
            margin-left: 8px;
            display: inline-flex;
        }

        &:only-child {
            margin-right: 0;
        }
    }

    .tree-select {
        [data-id='tree-select'] {
            > div > div > div {
                font-size: 14px;
            }

            .multiple-select-selected-values,
            .single-select-selected-values {
                color: rgb(0, 71, 204)
            }

            .select-placeholder {
                color: #333;
            }
        }
    }

    .action-link {
        color: #005aff;
        cursor: pointer;
    }

    .action-btn {
        margin: 0 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .check-box-label {
        font-size: 13px;
    }

    .left-bar {
        display: flex;
        align-items: center;
        flex-basis: auto;
        transition: all 0.3s;
        gap: 8px;
        padding-right: 10px;
        svg {
            vertical-align: baseline;
        }
    }

    .right-bar {
        font-size: 13px;
        margin-left: auto;
        &:focus {
            outline: none;
            .action,
            .filter-badge {
                outline: none;
            }
        }
        .action {
            &:hover,
            &:focus {
                color: #ff7d55;
                .filter-badge {
                    background: #ff7d55;
                    color: #fff;
                }
            }
        }
        .quick-create-job-alert {
            display: flex;
            align-items: center;
            align-content: center;
            > span {
                margin-right: 8px;
                font-size: 14px;
            }
            > div {
                > label {
                    display: none;
                }
            }
        }
    }

    .dropdown-action {
        position: relative;
        flex-basis: auto;
    }

    .dropdown-container {
        background: white;
        z-index: 5;
        border-radius: 6px;
        box-shadow: 0px 2px 4px ${Colors.cardShadow};
        border: 1px solid #e8e8e8;
        padding: 16px;
        width: 420px;

        /* .arrow-up {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -8px;
            z-index: 5;
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 8px solid #e8e8e8;

            &:after {
                content: '';
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 1.5px;
                z-index: 5;
                width: 0;
                height: 0;
                border-left: 6.5px solid transparent;
                border-right: 6.5px solid transparent;
                border-bottom: 6.5px solid white;
            }
        } */
    }

    .dropdown-row {
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;

        > div {
            flex: 1 1 0;
        }
    }

    .desktop-sort-extra-row {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: nowrap;
        margin-top: 8px;
    }

    .filter-bar-extra-filters-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
    }

    .filter-bar-extra-filters-dashed {
        position: relative;
        border-radius: 8px;
        overflow: visible;
        flex: 0 0 auto;
    }

    .filter-bar-extra-filters-dashed--no-highlight .filter-bar-extra-filters-dashed-svg {
        display: none;
    }

    .filter-bar-extra-filters-dashed-svg {
        position: absolute;
        top: -3px;
        left: -4px;
        width: calc(100% + 8px);
        height: calc(100% + 6px);
        pointer-events: none;
        z-index: 0;
        overflow: visible;
        transform: translateZ(0);
    }

    @keyframes filter-bar-extra-dashed-stroke {
        from {
            stroke-dashoffset: 0;
        }
        to {
            stroke-dashoffset: 1000;
        }
    }

    .filter-bar-extra-filters-dashed-line {
        stroke-dasharray: 6, 6;
        stroke-width: 1.5px;
        fill: transparent;
        stroke: #005aff;
        shape-rendering: geometricPrecision;
        will-change: stroke-dashoffset;
        animation: filter-bar-extra-dashed-stroke 30s linear infinite;
    }

    @media (prefers-reduced-motion: reduce) {
        .filter-bar-extra-filters-dashed-line {
            animation: none;
            will-change: auto;
        }
    }

    .filter-bar-extra-filters-dashed-inner {
        position: relative;
        z-index: 1;
    }

    .filter-bar-extra-filters-clear {
        flex-shrink: 0;
        height: 40px;
        border: 0;
        background: transparent;
        color: #666;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        padding: 0 4px;
        cursor: pointer;
        white-space: nowrap;
        outline: none !important;
    }

    .filter-bar-extra-filters-clear:hover {
        color: #005aff;
    }

    .filter-bar-extra-filters-callout {
        position: absolute;
        bottom: -40px;
        flex-shrink: 0;
        max-width: min(380px, 28vw);
        background: #005aff;
        color: #fff;
        border-radius: 8px;
        padding: 10px 36px 10px 14px;
        box-shadow: 0 2px 8px rgba(0, 90, 255, 0.25);
        margin-left: ${({ $language }) => ($language === 'en' ? '10px' : '-50px')};
        
        z-index: 1;
    }

    .filter-bar-extra-filters-callout::before {
        content: '';
        position: absolute;
        top: -7px;
        left: 45%;
        transform: none;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #005aff;
    }

    .filter-bar-extra-filters-callout-text {
        margin: 0;
        font-size: 13px;
        line-height: 1.35;
        font-weight: 500;
    }

    .filter-bar-extra-filters-callout-close {
        position: absolute;
        top: 3px;
        right: 4px;
        width: 28px;
        height: 28px;
        padding: 0;
        border: 0;
        background: transparent;
        color: inherit;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        line-height: 1;
    }

    .dropdown-heading {
        margin-bottom: 15px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 1.125rem;
    }

    .filter-badge {
        background: #005aff;
        color: white;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        margin-left: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: 0.25s;
    }

    .custom-drop-down {
        [id='multiple-radio'] > div:first-child,
        [data-id='tree-select'] > div:first-child,
        > div > div > div:first-child {
            border: 1px solid ${colors.neutral[90]};
        }
    }

    @media screen and (max-width: 991px) {
        .desktop {
            display: none;
        }

        .mobile {
            display: flex;
            flex-direction: column;
            padding: 12px 0;
            align-items: stretch;
            background: white;

            .sort-bar-extra-filters-mobile-wrap {
                flex: 0 0 auto;
                width: 100%;
                padding: 0 12px 4px;
            }

            .mobile-sort-bar-row {
                display: flex;
                align-items: center;
                width: 100%;

                > div {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex: 1;

                    svg {
                        width: 20px;
                        height: 20px;
                    }

                    > .filter-filled {
                        position: relative;
                        display: inline-flex;

                        > .filter-number {
                            position: absolute;
                            right: -6px;
                            top: -2px;
                            width: 60%;
                            height: 60%;
                            font-size: 0.6rem;
                            display: inline-flex;
                            border-radius: 50%;
                            border: 1px solid white;
                            background: #f85a5a;
                            align-items: center;
                            justify-content: center;
                            color: white;
                        }

                        ~ .label {
                            margin-left: 15px;
                        }
                    }

                    .label {
                        margin-left: 10px;
                        text-transform: uppercase;
                        font-weight: normal;
                    }
                }
            }
        }
    }
`

export const StyledModalFilter = styled.div`
    .filter-item-container {
        background: #fff;
        padding: 16px;
        margin-top: 8px;
        border: 1px solid #ececec;
    }
`

export const StyledClearFilterLink = styled.button`
    padding: 0;
    display: block;
    margin-left: auto;
    font-size: 12px;
    line-height: 15px;
    text-transform: uppercase;
    max-width: 62px;
`

export const FilterWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    border-radius: 6px;
    transition: 0.25s;

    :hover {
        background-color: ${Colors.tagSelectBorder};
    }
    [data-check-state] > label > span {
        max-width: initial;
    }
`

export const MoreTitle = styled.p`
    color: ${Colors.text};
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 8px;
`

export const MoreFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
`

export const MoreFooterRight = styled.div``

export const ClearAllText = styled.div`
    font-size: 14px;
    line-height: 18px;
    color: ${Colors.primary};
    padding: 8px 0;
    cursor: pointer;
`

export const SelectedBenefit = styled.span`
    font-size: 12px;
    margin: 0 5px 0 10px;
    color: ${Colors.text + '99'};
    line-height: 1;
`

export const Clear = styled.span`
    color: ${Colors.primary};
    font-size: 14px;
    cursor: pointer;
`

export const BottomSheetFooter = styled.div`
    display: flex;
    gap: 8px;
    margin: 16px 0;

    > button {
        flex: 1;
    }
`


export const StyledFilterSalary = styled.div<{ isHighlight?: boolean; isActive?: boolean; height?: string; borderRadius?: string, width?: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${({ height }) => height || '40px'};
    padding: 4px;
    border-radius: ${({ borderRadius }) => borderRadius || '8px'};
    transition: 0.25s;
    position: relative;
    cursor: pointer;
    border: ${({ isHighlight, isActive }) => {
        if (isHighlight) return 'none'
        if (isActive) return `1px solid #005aff`
        return `1px solid ${colors.neutral[80]}`
    }};
    background-color: ${({ isActive }) => (isActive ? '#eff5ff' : 'transparent')};
    color: ${({ isActive }) => (isActive ? '#003699' : 'inherit')};

    ${({ isHighlight, isActive }) =>
        !isHighlight &&
        !isActive &&
        `
        &:hover {
            border: 1px solid #80ADFF;
        }
    `}

    @keyframes svgAnimation {
        from {
            stroke-dashoffset: 0;
        }
        to {
            stroke-dashoffset: 1000;
        }
    }

    ${({ isHighlight }) =>
        isHighlight &&
        `
        svg {
            position: absolute;
            top: 0;
            left: 0;
            pointer-events: none;
        }
        .line {
            stroke-dasharray: 6, 6;
            stroke-width: 3px;
            fill: transparent;
            stroke: #005aff;
            animation: svgAnimation 30s linear infinite;
        }
    `}
`
